// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1vX3M","title":"Images45_title__2YVnj","images":"Images45_images__r_QNu"};